import React from 'react'
import './style.scss'

const PrimarySquareCard = ({isActive, logo}) => {
  let activeClass = isActive && 'primarySquareCard-wrapper--active'
  return (
    <div className={`primarySquareCard-wrapper ${activeClass}`} style={{backgroundImage: 'url(' + logo.file.url + ')'}} />
  )
}

export default PrimarySquareCard



// WEBPACK FOOTER //
// ./src/components/primary-square-card/index.js